module.exports = __webpack_public_path__ + "img/database.a37541e3.svg";